import { supabase } from '../lib/supabase';

export const feedbackService = {
  async submitFeedback({ email, rating, message, page }) {
    try {
      console.log('📤 feedbackService.submitFeedback called');

      // NOTE: no .select() after .insert() — anon has no SELECT policy on
      // `feedback` (and shouldn't, to keep other users' feedback private).
      // Asking for the row back would trigger an RLS visibility error even
      // though the insert itself succeeded.
      const { error } = await supabase
        ?.from('feedback')
        ?.insert([{
          email: email?.trim() || null,
          rating: rating || null,
          message: message?.trim(),
          page: page || 'beta',
        }]);

      if (error) {
        console.error('❌ Supabase feedback insert error:', error);
        throw error;
      }

      console.log('✅ Feedback submitted');
      return { success: true };
    } catch (error) {
      console.error('❌ feedbackService.submitFeedback error:', error);
      return {
        success: false,
        error: error?.message || 'Failed to submit feedback',
      };
    }
  },
};
